import { render, staticRenderFns } from "./TrekkSoft.vue?vue&type=template&id=3d370963&"
import script from "./TrekkSoft.vue?vue&type=script&lang=js&"
export * from "./TrekkSoft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports